import { useState } from 'react';
import { MISSION_BY_ID } from '../../data/missions';
import { HUMAN_PLAYER_INDEX } from '../../domain/types';
import { useGameStore } from '../../store/gameStore';

export function MissionBetPanel() {
  const game = useGameStore((s) => s.game);
  const dispatch = useGameStore((s) => s.dispatch);
  const { phase, players, activePlayerIndex, missionDraftHands } = game;
  const human = players[HUMAN_PLAYER_INDEX];
  const [betAmount, setBetAmount] = useState(1);
  const [turn4Step, setTurn4Step] = useState<'right' | 'keep'>('right');
  const [turn4FirstIndex, setTurn4FirstIndex] = useState<number | null>(null);

  if (!human) return null;

  if (phase === 'mission_draft' && activePlayerIndex === HUMAN_PLAYER_INDEX) {
    const hand = missionDraftHands[HUMAN_PLAYER_INDEX] ?? [];
    return (
      <div className="overlay-panel max-h-[40vh] overflow-y-auto p-4">
        <h2 className="text-sm font-semibold text-amber-100">이번에 고를 카드</h2>
        <p className="mb-2 text-xs text-white/65">1장 선택 · 게임 내내 보관됩니다</p>
        {hand.map((id) => {
          const m = MISSION_BY_ID[id];
          if (!m) return null;
          return (
            <button
              key={id}
              type="button"
              className="overlay-button-ghost mb-2 min-h-[44px] w-full text-left"
              onClick={() => dispatch({ type: 'MISSION_DRAFT_PICK', playerIndex: HUMAN_PLAYER_INDEX, missionId: id })}
            >
              <span className="block font-semibold">{m.name}</span>
              <span className="block text-xs text-white/65">{m.description}</span>
              <span className="mt-1 inline-block text-xs text-amber-300">배당 ×{m.payout}</span>
            </button>
          );
        })}
      </div>
    );
  }

  if (phase === 'mission_select' && activePlayerIndex === HUMAN_PLAYER_INDEX) {
    return (
      <div className="overlay-panel max-h-[40vh] overflow-y-auto p-4">
        <h2 className="text-sm font-semibold text-amber-100">미션 카드 선택</h2>
        {human.missionHand.map((id) => {
          const m = MISSION_BY_ID[id];
          if (!m) return null;
          return (
            <button
              key={id}
              type="button"
              className="overlay-button-ghost mb-2 min-h-[44px] w-full text-left"
              onClick={() => dispatch({ type: 'SELECT_MISSION', playerIndex: HUMAN_PLAYER_INDEX, missionId: id })}
            >
              <span className="block font-semibold">{m.name}</span>
              <span className="block text-xs text-white/65">{m.description}</span>
              <span className="mt-1 inline-block text-xs text-amber-300">배당 ×{m.payout}</span>
            </button>
          );
        })}
      </div>
    );
  }

  if (phase === 'betting' && activePlayerIndex === HUMAN_PLAYER_INDEX) {
    return (
      <div className="overlay-panel p-4">
        <h2 className="text-sm font-semibold text-amber-100">베팅</h2>
        <p className="text-xs text-white/70">보유 칩: {human.chips}점</p>
        <input
          type="range"
          min={1}
          max={Math.max(1, human.chips)}
          value={Math.min(betAmount, human.chips)}
          onChange={(e) => setBetAmount(Number(e.target.value))}
          className="mt-2 w-full touch-manipulation"
        />
        <p className="text-center text-sm">{Math.min(betAmount, human.chips)}점 베팅</p>
        <button
          type="button"
          className="overlay-button-primary mt-2 min-h-[44px] w-full"
          onClick={() => dispatch({ type: 'PLACE_BET', playerIndex: HUMAN_PLAYER_INDEX, amount: Math.min(betAmount, human.chips) })}
        >
          베팅 확정
        </button>
      </div>
    );
  }

  if (phase === 'draft' && activePlayerIndex === HUMAN_PLAYER_INDEX && human.tray.length > 0) {
    if (game.draftTurn === 4 && human.tray.length === 2) {
      return (
        <div className="overlay-panel p-4">
          <h2 className="text-sm font-semibold text-amber-100">
            {turn4Step === 'right' ? '1/2: 오른쪽에 줄 주사위' : '2/2: 5번 칸에 남길 주사위'}
          </h2>
          <div className="mt-2 flex flex-wrap justify-center gap-2">
            {human.tray.map((value, index) => (
              <button
                key={index}
                type="button"
                className="overlay-button-ghost min-h-[44px] min-w-[3rem]"
                onClick={() => {
                  if (turn4Step === 'right') {
                    setTurn4FirstIndex(index);
                    setTurn4Step('keep');
                  } else if (turn4FirstIndex !== null) {
                    dispatch({
                      type: 'DRAFT_TURN4',
                      playerIndex: HUMAN_PLAYER_INDEX,
                      toRightTrayIndex: turn4FirstIndex,
                      keepTrayIndex: index,
                    });
                    setTurn4Step('right');
                    setTurn4FirstIndex(null);
                  }
                }}
              >
                🎲 {value}
              </button>
            ))}
          </div>
        </div>
      );
    }

    return (
      <div className="overlay-panel p-4">
        <h2 className="text-sm font-semibold text-amber-100">오른쪽에 배치할 주사위</h2>
        <div className="mt-2 flex flex-wrap justify-center gap-2">
          {human.tray.map((value, index) => (
            <button
              key={index}
              type="button"
              className="overlay-button-ghost min-h-[44px] min-w-[3rem]"
              onClick={() => dispatch({ type: 'DRAFT_PLACE', playerIndex: HUMAN_PLAYER_INDEX, trayIndex: index })}
            >
              🎲 {value}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return null;
}
